import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["icon"];
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Select } from 'foundations-components/transitional/components/Select';
import getLang from 'I18n/utils/getLang';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useRef } from 'react';
import debounce from 'react-utils/debounce';
import { GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY as PUBLIC_GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY } from '../../../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontPublicRpc.dfc.new';
import { GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY } from '../../../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontRpc.dfc.new';
import { useLazyAppContextQuery } from '../../../hooks/useAppContextQuery';
import { useAsyncFilterOptions } from '../../hooks/useAsyncFilterOptions';
import { useFilterChangeHandler } from '../../hooks/useFilterChangeHandler';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const stripIcon = options => options.map(_ref => {
  let rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return rest;
});
export function PaginatedSelectFilter({
  filter,
  menuWidth
}) {
  var _asyncFilterOptionsRe;
  const params = useSearchParams();
  const handleChange = useFilterChangeHandler({
    filter,
    isMulti: true
  });
  const [fetch] = useLazyAppContextQuery({
    app: GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY,
    public: PUBLIC_GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY
  });
  const asyncFilterOptionsResult = useAsyncFilterOptions();
  const debouncedFetch = debounce(fetch, 250);
  const prevInputRef = useRef('');
  const accumulatedOptionsRef = useRef([]);
  if (!filter) return null;
  const {
    label,
    field,
    placeholder
  } = filter;
  return /*#__PURE__*/_jsxs("div", {
    children: [label && /*#__PURE__*/_jsx(FormLabel, {
      htmlFor: `eco_${field}`,
      children: label
    }), /*#__PURE__*/_jsx(Select, {
      menuWidth: menuWidth,
      filterOptions: false,
      id: `eco_${field}`,
      loadOptions: (input, callback, pagination) => {
        var _pagination$page;
        debouncedFetch({
          variables: {
            field: field,
            language: getLang(),
            page: (_pagination$page = pagination === null || pagination === void 0 ? void 0 : pagination.page) !== null && _pagination$page !== void 0 ? _pagination$page : 0,
            search: input
          },
          onCompleted: data => {
            var _data$result$nextPage;
            const options = stripIcon(data.result.options);
            if (input !== prevInputRef.current) {
              prevInputRef.current = input;
              accumulatedOptionsRef.current = options;
            } else {
              accumulatedOptionsRef.current = [...accumulatedOptionsRef.current, ...options];
            }
            callback(null, {
              options: accumulatedOptionsRef.current,
              pagination: {
                hasMore: data.result.hasMoreOptions,
                length: data.result.total,
                page: (_data$result$nextPage = data.result.nextPage) !== null && _data$result$nextPage !== void 0 ? _data$result$nextPage : 0
              }
            });
          }
        });
      },
      multi: filter.isMulti,
      onChange: handleChange,
      options: ((_asyncFilterOptionsRe = asyncFilterOptionsResult.data) === null || _asyncFilterOptionsRe === void 0 ? void 0 : _asyncFilterOptionsRe.result.filterOptions[filter.field]) && stripIcon(asyncFilterOptionsResult.data.result.filterOptions[filter.field]),
      placeholder: placeholder,
      value: params.getList(field)
    })]
  });
}